import React, { useState } from "react";
import axios from "axios";

function MobileVerify() {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [requestId, setRequestId] = useState("");
  const [code, setCode] = useState("");
  const [message, setMessage] = useState("");

  const requestCode = async () => {
    try {
      const res = await axios.post("http://localhost:3001/api/request-code", {
        phoneNumber,
      });
      console.log(res.data);
      setRequestId(res.data.requestId);
      setMessage("Verification code sent!");
    } catch (err) {
      setMessage("Error requesting code");
    }
  };

  const verifyCode = async () => {
    try {
      const res = await axios.post("http://localhost:3001/api/verify-code", {
        requestId,
        code,
      });
      console.log(res.data);
      setMessage(res.data.message);
    } catch (err) {
      setMessage("Verification failed");
    }
  };

  return (
    <div style={{ padding: 20, maxWidth: 400 }}>
      <h2>Phone Verification (Vonage)</h2>

      {!requestId ? (
        <>
          <input
            type="text"
            placeholder="Enter phone number (e.g. +14155550100)"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            style={{ width: "100%", marginBottom: 10 }}
          />
          <button onClick={requestCode}>Send Code</button>
        </>
      ) : (
        <>
          <input
            type="text"
            placeholder="Enter code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            style={{ width: "100%", marginBottom: 10 }}
          />
          <button onClick={verifyCode}>Verify</button>
        </>
      )}

      <p>{message}</p>
    </div>
  );
}

export default MobileVerify;
